import { request } from './client';

// Estimate shipping cost for a destination + cart amount.
// Returns shipping amounts plus currencyCode: INR domestic, USD international.
export const apiEstimateShipping = ({ pincode, state, city, country, amount, itemCount, isCOD = false, shippingMethod = 'standard' }) => {
  const params = new URLSearchParams();
  if (country) params.set('country', country);
  if (pincode) params.set('pincode', pincode);
  if (state) params.set('state', state);
  if (city) params.set('city', city);
  if (amount != null) params.set('amount', String(amount));
  params.set('itemCount', String(itemCount));
  if (isCOD) params.set('cod', 'true');
  params.set('shippingMethod', shippingMethod);
  return request(`/shipping/estimate?${params.toString()}`);
};
